"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Success = function Success(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.5962 7.40384C15.5329 6.34048 14.1337 5.67872 12.6372 5.53131C11.1406 5.38391 9.6392 5.75997 8.38883 6.59544C7.13845 7.4309 6.21644 8.67407 5.7799 10.1131C5.34336 11.5522 5.4193 13.0981 5.99477 14.4874C6.57025 15.8768 7.60966 17.0236 8.93589 17.7325C10.2621 18.4414 11.7931 18.6685 13.2681 18.3751C14.743 18.0817 16.0705 17.286 17.0246 16.1236C17.9786 14.9611 18.5 13.5038 18.5 12C18.5023 11.1461 18.3353 10.3002 18.0085 9.51125C17.6817 8.72231 17.2017 8.00602 16.5962 7.40384Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10 15.4998C9.9344 15.4999 9.86941 15.487 9.80879 15.4619C9.74817 15.4368 9.6931 15.4 9.64676 15.3535L7.64677 13.3535C7.55408 13.2596 7.5023 13.1329 7.50273 13.0009C7.50316 12.869 7.55576 12.7426 7.64906 12.6493C7.74235 12.556 7.86876 12.5034 8.0007 12.5029C8.13263 12.5025 8.25939 12.5543 8.35329 12.647L10.3533 14.647C10.4232 14.7168 10.4707 14.8058 10.49 14.9028C10.5093 14.9997 10.4994 15.1001 10.4616 15.1914C10.4238 15.2827 10.3597 15.3607 10.2776 15.4156C10.1954 15.4705 10.0988 15.4998 10 15.4998Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10 15.5001C9.90111 15.5001 9.80444 15.4708 9.72222 15.4158C9.63999 15.3609 9.57591 15.2828 9.53806 15.1915C9.50022 15.1001 9.49031 14.9996 9.50961 14.9026C9.5289 14.8056 9.57652 14.7165 9.64645 14.6466L15.6464 8.64656C15.7404 8.5536 15.8673 8.50161 15.9995 8.50195C16.1316 8.5023 16.2583 8.55495 16.3517 8.64841C16.4452 8.74186 16.4978 8.86851 16.4982 9.00066C16.4985 9.13282 16.4465 9.25974 16.3535 9.35367L10.3535 15.3537C10.3072 15.4002 10.252 15.437 10.1914 15.4622C10.1307 15.4873 10.0657 15.5002 10 15.5001Z",
    fill: props.foregroundColor
  }));
};

Success.defaultProps = {
  altText: "Success",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Success.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Success;
exports.default = _default;